// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper__dQ-o1Z8suB2G3","desc":"desc__BH4E78UNpjca1"};